/////////////// Helper Methods
const sendRequest = (url, requestData, useJsonParser = true) => new Promise((resolve, reject) => {
  const defaultErrorCatcher = err => reject({ ok: false, status: err.status, data: err });
  fetch(url, requestData).then(rawResponse => {
    rawResponse[useJsonParser ? 'json' : 'text']().then(parsedResult => {
      const resolveInformation = {
        ok: rawResponse.ok,
        status: rawResponse.status,
        data: parsedResult
      };
      rawResponse.ok ? resolve(resolveInformation) : reject(resolveInformation);
    }, defaultErrorCatcher);
  }, defaultErrorCatcher);
});
const defaultCatcherHttpRequest = (message, handleError403 = false, title = 'Ocurrió un error') => err => {
  UI.hideLoader();
  UI.message({ title, content: message, accept: 'Aceptar' });
  if (handleError403 && err.status === 403) {
    window.location.href = 'login.html'
  }else{
    console.error(err);
  }
};

/////////////// Global Variables
const sessionToken = localStorage.getItem('session');
const selectMenu = document.querySelector('#selectMenu'),
      selectCategoryContainer = document.getElementById('divCategorySelector'),
      selectCategory = document.querySelector('#selectCategory'),
      rightFormContainer = document.querySelector('.profile-form-der'),
      saveButton = document.getElementById('btnSave'),
      labelSelectedCatgory = document.querySelector('#labelSelectedCategory'),
      iconImgContainer = document.querySelector('#iconImgContainer'),
      iconImgInput = document.getElementById('category-icon-input');
let storeInfo = {}, selectedMenu, selectedCategory;

/////////////// Page load
const userSessionToken = localStorage.getItem('session');
window.addEventListener("load", () => {
  enableOrDisableSaveButton(false);
  const storeId = localStorage.getItem("currentStore");
  const objContext = JSON.parse(sessionStorage.getItem("context"));
  if(storeId == null || objContext == null || objContext.store_name == null) {
      location.href = 'index.html';
  }
  else {
      document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';
      UI.hideLoader();
      document.querySelector('.sidebar-profile-img img').src = objContext.store_image
      document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '')
      loadStoreInfo(storeId);
  }
});

const loadStoreInfo = (storeId) => {
    UI.showLoader();
    sendRequest(BASE_URLS.Dinny.api + `/stores/${storeId}?req_id=${new Date().getTime()}`, {
      headers:{
        "Authorization": sessionToken
      }
    }).then(storeInfoResponse => {
      UI.hideLoader();
      selectMenu.innerHTML = '<option value="0" selected="">Selecciona un menú</option>';
      storeInfo = storeInfoResponse.data;
      if(storeInfo.menu && storeInfo.menu != null && storeInfo.menu.length > 0){
        storeInfo.menu.forEach((element) => {
              selectMenu.insertAdjacentHTML(
                  'beforeend',
                  `<option value='${element.id}'>${element.name}</option>`
              )
          });
      }else{
        return UI.message({ title: 'Datos incompletos', content: 'Para poder asignar imágenes es necesario que el establecimiento cuente al menos con un menú sincronizado con Dinny.<br/><br/>Por favor, crea un menú en tu administrador y sincronízalo con Dinny para que puedas asignar imágenes.', accept: 'Aceptar' }, function(){
              location.href='index.html';
          });
      }
    }, defaultCatcherHttpRequest('Ocurrió un error al cargar los banners.', true));
}

/////////////// Event Listeners
selectMenu.addEventListener('change', (e) => {
  enableOrDisableSaveButton(false);
  selectCategory.innerHTML = '<option value="0" selected="">Selecciona una categoría</option>';
  if(selectMenu.value != "0"){
      selectedMenu = storeInfo.menu.find(x => x.id == selectMenu.value);
      if(selectedMenu != undefined){
          if(selectedMenu.categories && selectedMenu.categories != null && selectedMenu.categories.length > 0){
              selectedMenu.categories.forEach((element) => {
                  selectCategory.insertAdjacentHTML(
                      'beforeend',
                      `<option value='${element.id}'>${element.name}</option>`
                  );
              });
              selectCategoryContainer.style = "display:flex";
          }
          else{
            selectCategoryContainer.style = "display:none";
          }
      }
  }
  else{
    rightFormContainer.style.display = 'none';
    selectCategoryContainer.style = "display:none";
  }
});

selectCategory.addEventListener('change', (e) => {
  iconImgInput.value = '';
  enableOrDisableSaveButton(false);
  if(selectCategory.value != "0"){
      selectedCategory = selectedMenu.categories.find(x => x.id == selectCategory.value);
      if(selectedCategory != undefined) {
        const categoryImage = selectedCategory.thumbnail_image;
        console.log(categoryImage, typeof categoryImage);
        if (typeof categoryImage === 'string' && categoryImage.length > 0) loadImage(createImage(categoryImage));
        else resetImgContainer(true);
        labelSelectedCatgory.innerHTML = `Agregar el icono de la categoría seleccionada: ${selectedCategory.name}`;
        rightFormContainer.style.display = 'grid';
      }
  }else {
    rightFormContainer.style.display = 'none';
  }
}); 

saveButton.addEventListener('click', e => {
  if (selectMenu.value != '0' && selectCategory.value != '0' && rightFormContainer.style.display === 'grid'){
    changeIcon();
  }
  else{
     return UI.message({ title: 'Error', content: 'Faltan llenar algunos datos.', accept: 'Aceptar' });
  }
});
/////////////// Logic
const previewPicture = (e) => {
  if (e.target.files[0]){
    tryLoadImage(URL.createObjectURL(e.target.files[0]));
  }
  else {
    enableOrDisableSaveButton(false);
  }
};
const enableOrDisableSaveButton = isEnabled => {
  if (isEnabled) {
    saveButton.style.pointerEvents = "auto";
    saveButton.style.cursor = "pointer";
    saveButton.style.opacity = 1;
  }
  else{
    saveButton.style.pointerEvents = "none";
    saveButton.style.cursor = "default";
    saveButton.style.opacity = 0.5;
    iconImgInput.value = '';
  }
};
const resetImgContainer = (hide) => {
  iconImgContainer.innerHTML = ""; 
  iconImgContainer.style.display = hide === true ? 'none' : 'block';
};
const createImage = src => {
  const tImage = document.createElement("img");
  tImage.id = 'categoryIcon';
  tImage.src = src;
  return tImage;
};
const loadImage = (imgObject) => {
  resetImgContainer(false);
  iconImgContainer.appendChild(imgObject);
};
const tryLoadImage = (src) => {
  const oldThumbnail = iconImgContainer.querySelector('#categoryIcon');
  const showError = message => {
    if (oldThumbnail) loadImage(oldThumbnail);
    else resetImgContainer(true);
    UI.message({ title: 'Error al cargar imagen', content: message, accept: 'Aceptar' });
    enableOrDisableSaveButton(false);
  };
  const outputImage = createImage(src);
  outputImage.onload = () => {
    URL.revokeObjectURL(outputImage.src) // free memory
    if (iconImgInput.files[0].type !== 'image/png'){
      showError('Solo se aceptan imagenes png.');
    }
    else if (outputImage.width > 260 || outputImage.height > 260 || outputImage.width < 50 || outputImage.height < 50){
      showError('Por favor, seleccione una imagen con una dimensión mínima de 50x50 pixeles y máxima de 260x260 pixeles.');
    }
    else if (iconImgInput.files[0].size > 4096000){
      showError('Por favor, seleccione una imagen de menos de 4MB.');
    }
    else {
      enableOrDisableSaveButton(true);
      loadImage(outputImage);
    }
  };
};

const changeIcon = () => {
  const selectedImage = iconImgInput.files[0];
  if(selectedImage == null || selectedImage === "undefined" || iconImgContainer.querySelector('#categoryIcon') === null) {
      return UI.message({ title: 'Faltan datos', content: 'Seleccione una imagen para la categoría.', accept: 'Aceptar' });
  }
  UI.showLoader();
  const iconData = {
    store_id: storeInfo.store_id,
    menu_id: selectMenu.value,
    category_id: selectCategory.value
  };
  const objReader = new FileReader();
  objReader.readAsDataURL(selectedImage);
  objReader.onload = e => {
    let base64string = e.target.result;
    base64string = base64string.replace(base64string.substring(0, base64string.indexOf(',') + 1), "");
    const requestDataUploadPicture = {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
          key: 'image/' + iconData.store_id + '/' + iconData.menu_id + '/category/' + new Date().toISOString().replace(/:/g, '').replace(/-/g, '').replace(/\./g, '') + '.' + selectedImage.name.split('.').pop(),
          content: base64string,
          contentType: selectedImage.type
      }),
      headers:{
          authorization: sessionToken
      }
    };
    sendRequest(BASE_URLS.Standalone.api + '/picture', requestDataUploadPicture).then(responseUploadPicture => {
      iconData.picture_url = responseUploadPicture.data;
      const requestDataChangeIcon = {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify(iconData),
        headers:{
            "Authorization": sessionToken
        }
      };
      sendRequest(BASE_URLS.Dinny.api + '/category-icons/update', requestDataChangeIcon).then(changeIconResponse => {
        UI.hideLoader();
        selectedCategory.thumbnail_image = iconData.picture_url;
        enableOrDisableSaveButton(false);
      }, defaultCatcherHttpRequest('Ocurrió un error al cambiar la imagen.'));
    }, defaultCatcherHttpRequest('Ocurrió un error al guardar la imagen.', true));
  };
};